import { StyledModalBlur } from "./ModalBlur.styles";

const ModalBlur = ({ children }) => {
  return <StyledModalBlur>{children}</StyledModalBlur>;
};

export default ModalBlur;
